import { useCallback, useState } from 'react';
import type { CalculatedMeasure } from 'src/components/star-grid/datasets/datasetTypes';

const BLANK: CalculatedMeasure = { name: '', formula: '', per_row: false, format: 'currency' };

/** The measures the user defines as formulas in the Map step, kept apart from the profiled table columns. */
export function useCalculatedMeasures() {
  const [measures, setMeasures] = useState<CalculatedMeasure[]>([]);
  const add = useCallback(() => setMeasures((prev) => [...prev, BLANK]), []);
  const update = useCallback(
    (index: number, measure: CalculatedMeasure) => setMeasures((prev) => prev.map((existing, at) => (at === index ? measure : existing))),
    []
  );
  const remove = useCallback((index: number) => setMeasures((prev) => prev.filter((_, at) => at !== index)), []);
  return { measures, seed: setMeasures, add, update, remove };
}
